/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createContext } from 'fierry/react';

import Rpc from 'fierry/rpc';
import Routes from 'solis/rpc';

import Application from 'solis/data/application';
import Galaxy from 'solis/application/galaxy';

import AuthSync from 'solis/application/auth.sync';
import OfflineUser from 'solis/application/offline.user';


const Context = createContext();


Context.Export = ({ currentUser, children }) =>
(
  <Rpc.Export as = {Context} location = 'solis' Application = {Application} routes = {Routes}>

    <OfflineUser user = {currentUser} />

    <AuthSync />

    <Galaxy.Export application = {Context} children = {children} />

  </Rpc.Export>
);


export default Context;
